import { Stack } from '@mui/material';
import Decimal from 'decimal.js';

import { DiagramIcon } from '@/components/icons/DiagramIcon';
import { ActionCard } from '@/components/layout/ActionCard/ActionCard';
import { useDispositiveProvisionsContext } from '@/modules/dispositiveProvisions/contexts/dispositiveProvisions.context';
import { isBeneficiaryDesignationEntityType } from '@/modules/dispositiveProvisions/dispositiveProvisions.label';
import { SpecifyDispositiveProvisionsButton } from '@/modules/dispositiveProvisions/SpecifyDispositiveProvisionsButton';
import { COLORS } from '@/styles/tokens/colors';

import { ActiveDispositionTab } from './hooks/useDispositiveProvisionsListViewTab';

type NoDispositionsProps = {
  currentNodeValue?: Decimal;
} & ActiveDispositionTab;

export function NoDispositions({
  currentNodeValue,
  ...rest
}: NoDispositionsProps) {
  const { entityType } = useDispositiveProvisionsContext();
  const isBenDesignation = isBeneficiaryDesignationEntityType(entityType);
  const label = isBenDesignation ? 'beneficiary designations' : 'dispositions';

  return (
    <Stack p={4} alignItems="center">
      <ActionCard
        variant="noCard"
        heading={`Specify ${label}`}
        description={`No ${label} have been specified for this entity`}
        icon={<DiagramIcon size={32} color={COLORS.TEXT.PRIMARY} />}
        sx={{ maxWidth: 400 }}
        actions={
          <SpecifyDispositiveProvisionsButton
            currentNodeValue={currentNodeValue}
            {...rest}
          />
        }
      />
    </Stack>
  );
}
